import { MessageCircle, Mail, Instagram, Youtube } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data";

export default function Footer() {
  const socials = [
    { icon: MessageCircle, href: CONTACT.whatsapp, label: "WhatsApp" },
    { icon: Mail, href: `mailto:${CONTACT.email}`, label: "Email" },
    { icon: Instagram, href: CONTACT.instagram, label: "Instagram" },
    { icon: Youtube, href: CONTACT.youtube, label: "YouTube" },
    { icon: Youtube, href: CONTACT.youtubeHindi, label: "YouTube Hindi" },
  ];
  return (
    <footer data-testid="footer" className="noir grain text-[var(--cream)] pt-20 pb-10">
      <div className="gold-glow opacity-60" />
      <div className="section-pad relative z-10">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-[rgba(233,172,70,0.2)]">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src={CONTACT.logo} alt="Brahmsara logo" className="h-16 w-16 rounded-full object-cover ring-1 ring-[rgba(233,172,70,0.5)] shadow-[0_0_30px_rgba(233,172,70,0.3)]" />
              <div>
                <p className="font-serif-display text-4xl tracking-tight">Brahmsara</p>
                <p className="overline text-[0.5rem] mt-1">{CONTACT.tagline}</p>
              </div>
            </div>
            <p className="font-sans-ui text-sm text-[var(--cream)]/55 leading-relaxed font-light max-w-sm mt-6">
              A trusted practice blending ancient wisdom with a calm, modern presence — helping you reconnect with your inner wisdom.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-5">Explore</p>
            <div className="grid grid-cols-2 gap-y-3">
              {NAV_LINKS.map((l) => (
                <a key={l.id} href={`#${l.id}`} data-testid={`footer-${l.id}-link`} className="font-sans-ui text-sm text-white/60 hover:text-[var(--gold)] transition-colors">
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Connect</p>
            <div className="flex gap-3">
              {socials.map((s) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.label}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="w-11 h-11 flex items-center justify-center border border-white/25 rounded-full hover:border-[var(--gold)] hover:text-[var(--gold)] transition-colors duration-300"
                  >
                    <Icon size={18} strokeWidth={1.5} />
                  </a>
                );
              })}
            </div>
            <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="font-sans-ui text-sm text-white/60 mt-5 block hover:text-[var(--gold)] transition-colors">
              {CONTACT.whatsappDisplay}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="font-sans-ui text-sm text-white/60 mt-1 block hover:text-[var(--gold)] transition-colors">
              {CONTACT.email}
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="font-sans-ui text-xs text-white/40 tracking-wide">
            &copy; {new Date().getFullYear()} Brahmsara. All rights reserved.
          </p>
          <p className="font-sans-ui text-xs text-white/40 tracking-wide">
            Crafted with intention &middot; Founded by Shubham Jain
          </p>
        </div>
      </div>
    </footer>
  );
}
